<template>
    <div class="pdf-paginator">
        <template v-if="pageCount">
            <input :value="value" class="mr-1 page-input" min="1" :max="pageCount" type="number" @input="input" /> /
            <span class="ml-1">{{ pageCount }}</span>
        </template>
        <input v-else type="number" />
    </div>
</template>

<script>
export default {
    name: 'PDFPaginator',

    props: {
        value: Number,
        pageCount: Number,
    },

    watch: {
        pageCount() {
            this.$emit('input', 1);
        },
    },

    methods: {
        input(event) {
            this.$emit('input', parseInt(event.target.value, 10));
        },
    },
};
</script>

<style scoped>
.page-input {
    width: 2rem;
    text-align: center;
    border: 1px solid #f3f3f3;
    border-radius: 5px;
}
</style>
